// extracted by css-extract-rspack-plugin
export default {"SecondaryCTALink":"W9VW0"};